/** Hub frontend base URL for the Control Tower env (staging vs prod). */
export function platformFrontBase(env) {
  if (env === "prod" || env === "production") return "https://hub.zenyt.ai";
  return "https://staging.zenyt.ai";
}

/** Hub activity URL for a platform scan (V2 redirects /scans/:id → /runs/legacy-run-:id). */
export function hubScanUrl(env, scanId) {
  return `${platformFrontBase(env)}/scans/${scanId}`;
}

/** Hub Activity run detail URL for a V2 activity_run id (`run-…` or `legacy-run-…`). */
export function hubActivityRunUrl(env, runId) {
  return `${platformFrontBase(env)}/runs/${runId}`;
}
